<template>
    <div class="w-full">
        <p class="pt-2" v-if="hasEliteStatus">
            <span class="inline bg-gray-500 dark:bg-slate-600 text-white rounded-full px-2 mr-2">{{
                programStatus
            }}</span>
            <span class="text-xs text-gray-500 dark:text-gray-400">through {{ programStatusDate }}</span>
        </p>
    </div>
</template>
<script>
export default {
    props: {
        program: {
            type: Object || null,
        },
    },
    data: () => ({}),
    computed: {
        hasEliteStatus() {
            return this.program.program_user && this.program.program_user.has_elite_status === 'Y';
        },
        programStatus() {
            return this.program.program_user
                ? this.titleCase(this.program.program_user.elite_status)
                : null;
        },
        programStatusDate() {
            return this.program.expire_day
                ? this.program.expire_day + '/' + this.program.expire_month + '/YYYY'
                : '';
        },
    },
    methods: {
        titleCase(str) {
            return String(str)
                .toLowerCase()
                .split(' ')
                .map(function (word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(' ');
        },
    },
};
</script>
